import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import $ from 'jquery';
import { Alert } from '@paypalcorp/pp-react-alert';

import * as dateUtils from '../../guest-payment-components/util/dateUtils';
import CountrySelection from '../../guest-payment-components/CountrySelection';
import Email from '../../guest-payment-components/Email';
import CreateAccountPre from '../../guest-payment-components/CreateAccountPre';
// import AddressEntryField from 'react-address-entry-field';
import AddressEntryField from '../../components/address-entry-field';

import PaymentComponent from '../../containers/payment-component';
import PhoneComponent from '../../containers/phone-component';
import NameComponent from '../../containers/name-component';

import AddressCheckbox from '../../components/addressCheckbox';
import GuestTerms from '../../components/guestTerms';
import GuestSubmitButton from '../../components/guest-submit-button';

import * as AppActions from '../../actions/AppActions';
import AppStore from '../../stores/AppStore';
import AppDispatcher from '../../dispatcher/AppDispatcher';

import {
  addShake,
  parseErrorResponse,
  parseValErrResp,
  getErrFields,
  setCountryAndLocale,
} from '../../utility/helper';
import '../../utility/csrf';
import CancelAndReturn from '../../components/cancelAndReturn';

import * as FPT from '../../utility/fpt';
import constants from '../../utility/constants';
import { getCountryInfo } from '../../utility/localizer';
import TemplateData, {
  localsMessages,
  guestLocalsMessages,
} from '../../utility/getTemplateData';
import {
  formatAmount,
  getDateFormat,
  normalizeNumber,
} from '../../utility/formator';

import { isAmountGreaterThanZero } from '../../components/amount/amountUtils';

import withDonate from '../../components/guest/WithDonate';
import ThreeDSContainer from '../../components/threeDS/ThreeDSContainer';
import FormSectionHeading from '../../components/common/FormSectionHeading';

import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
// import _includes from 'lodash/includes';
// import _each from 'lodash/each';
import _keys from 'lodash/keys';
import _startsWith from 'lodash/startsWith';
import _clone from 'lodash/clone';
import RussiaGuestForm from './RussiaGuestForm';
import { startCustomCPLTrackingForConfirmationPage } from '../../utility/cpl';

const errorMessages = localsMessages('errors/service');
const landingErrorMessages = localsMessages('errors/landingerror');
const initialData = JSON.parse(
  document.getElementById('initialData').innerHTML || {}
);
const senderDetails = initialData.senderDetails || {};
const pre_address = senderDetails.address || {};

const defaultCardSpec = constants.DEFAULT_CARD_SPEC;

class GuestForm extends Component {
  static propTypes = {
    password: PropTypes.string,
  };

  constructor(props) {
    super(props);

    const savedFormData =
      this.props.getFormData() || TemplateData.formData || {};
    const hasSavedFormData = !_isEmpty(savedFormData);

    AppActions.changeCountry({ country: initialData.selectedCountry });
    const symbol = AppStore.getDonationSymbol() || '';
    const currency = AppStore.getDonationCode() || '';
    const amount = AppStore.getDonationAmount();
    let formattedAmount = '';
    if (amount) {
      formattedAmount = formatAmount({ currency, value: amount });
    }

    const formValues = this.getFormValues(savedFormData);

    this.state = {
      formatedAmount: formattedAmount,
      symbol: symbol,
      isRequired: true,
      isGuestFormValid: true,
      isCreateAccValid: true,
      postcodeHasError: false,
      passwordFieldsOpen: false,
      isSignUpPanel: false,
      legalCheckbox: false,
      guestAllowed: TemplateData.guestAllowed,
      memberMandatory: TemplateData.memberMandatory || false,
      recurringEnabled: TemplateData.recurringEnabled,
      charityCountry: TemplateData.charityCountry,
      validPassword: null,
      showCreateAccountPreErrors: false,
      assignedCountries: initialData.assignedCountries,
      supportedCountries: initialData.supportedCountries,
      countriesAllowed: initialData.countriesAllowed,
      DOBPattern:
        getDateFormat() ||
        getCountryInfo(initialData.selectedCountry).DOBPattern,
      cardSpecs: initialData.cardSpecs,
      initialData: initialData,
      addressLine1Error: '',
      addressCityError: '',
      addressStateError: '',
      addressZipError: '',
      card: {
        type: '',
        number: '',
        securityCode: '',
        expiration: '',
        dateOfBirth: '',
        startDate: '',
        issueNumber: '',
      },
      cardSpec: defaultCardSpec,
      consentShareAddress: false,
      donateNow: '',
      agreeAndDonate: '',
      errorMessages: errorMessages,
      errorMesages: [],
      errMessageCountry: '',
      errMessageCreditCard: '',
      errMessageExpiry: '',
      errMessageCSC: '',
      errMessageEmail: '',
      errMessagePhoneNumber: '',
      legalCheckboxErrorMsg: '',
      termsCheckBoxError: false,
      hasSavedFormData,
      ...formValues,
    };
  }

  componentDidMount() {
    // @TODO: What is this for?
    $('[type=password]').focus(() => {
      this.setState({ legalCheckboxErrorMsg: '' }); // eslint-disable-line
    });

    // Register for App Dispatcher Messages
    this.registerAppDispatcherMessages();

    if (TemplateData.senderCountryEligible === false) {
      // eslint-disable-next-line
      this.setState({
        errMessageCountry: landingErrorMessages.error.sendDonationNotAllowed,
      });
    }
  }

  componentWillUnmount() {
    AppDispatcher.unregister(this.dispatcherMessages);
  }

  registerAppDispatcherMessages() {
    this.dispatcherMessages = AppDispatcher.register((payload) => {
      if (payload.action && payload.action.actionType === 'CHANGE_AMOUNT') {
        const { action: { item: { amount } = {} } = {} } = payload;
        this.updateAmount(amount);
      }
      if (
        payload.action &&
        payload.action.actionType === 'UPDATE_SERVER_ERRORS'
      ) {
        const serverErrors = _get(payload, 'action.item.serverErrors');
        if (!_isEmpty(serverErrors)) {
          this.resetSensitiveFields();
        }
      }
    });
  }

  getFormValues(savedFormData) {
    let formValues;
    if (!_isEmpty(savedFormData)) {
      formValues = {
        country: savedFormData.country,
        // Auto fill form
        firstname: _get(savedFormData, 'user.firstName', ''),
        lastname: _get(savedFormData, 'user.lastName', ''),
        newAddress: {
          line1: _get(savedFormData, 'billingAddress.line1', ''),
          line2: _get(savedFormData, 'billingAddress.line2', ''),
          city: _get(savedFormData, 'billingAddress.city', ''),
          state: _get(savedFormData, 'billingAddress.state', ''),
          postcode: _get(savedFormData, 'billingAddress.postalCode', ''),
          country: _get(savedFormData, 'billingAddress.country', ''),
        },
        phone: {
          countryCode: _get(savedFormData, 'phone.countryCode', ''),
          number: _get(savedFormData, 'phone.number', ''),
          type: _get(savedFormData, 'phone.type', 'Mobile'),
        },
        user: {
          firstName: _get(savedFormData, 'user.firstName', ''),
          lastName: _get(savedFormData, 'user.lastName', ''),
          email: _get(savedFormData, 'user.email', ''),
          password: '',
          occupation: _get(savedFormData, 'user.occupation', ''),
          nationality: _get(savedFormData, 'user.nationality', ''),
          dateOfBirth: _get(savedFormData, 'user.dateOfBirth', ''),
          countryOfResidence: _get(
            savedFormData,
            'user.countryOfResidence',
            ''
          ),
        },
        email: _get(savedFormData, 'user.email', ''),
      };
    } else if (!TemplateData.isCountryChange) {
      formValues = {
        country: initialData.selectedCountry,
        // Auto fill form
        firstname: senderDetails.first_name || '',
        lastname: senderDetails.last_name || '',
        newAddress: {
          line1: pre_address.address1 || '',
          line2: pre_address.address2 || '',
          city: pre_address.city || '',
          state: pre_address.state || '',
          postcode: pre_address.zip || '',
          country: pre_address.iso_country || '',
        },
        phone: {
          countryCode: initialData.phoneNumberCountryCode || '',
          number:
            (senderDetails.phone && senderDetails.phone.phone_number) || '',
          type: 'Mobile',
        },
        user: {
          firstName: senderDetails.first_name || '',
          lastName: senderDetails.last_name || '',
          email: senderDetails.sender_email || '',
          password: '',
          occupation: '',
          nationality: '',
          dateOfBirth: '',
          countryOfResidence: '',
        },
        email: senderDetails.sender_email || '',
      };
    } else {
      formValues = this.clearFormValues();
    }

    return formValues;
  }

  clearFormValues() {
    const formValues = {
      country: initialData.selectedCountry,
      // Auto fill form
      firstname: '',
      lastname: '',
      newAddress: {
        line1: '',
        line2: '',
        city: '',
        state: '',
        postcode: '',
        country: '',
      },
      phone: {
        countryCode: '',
        number: '',
        type: 'Mobile',
      },
      user: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        occupation: '',
        nationality: '',
        dateOfBirth: '',
        countryOfResidence: '',
      },
      email: '',
    };

    return formValues;
  }

  updateAmount = (value) => {
    const currency = AppStore.getDonationCode() || '';
    this.setState({ formatedAmount: formatAmount({ currency, value }) });
  };

  /**********************
	PaymentComponent handlers
	**********************/
  // passed to component
  handleChangePaymentInfo = (card = {}) => {
    this.setState({ card: card });
  };

  /**********************
	NameComponent handlers
	**********************/
  // passed to component
  handleChangeNameInfo = (firstName, lastName) => {
    let { user = {} } = this.state;
    user.firstName = firstName;
    user.lastName = lastName;
    this.setState({ user: user });
  };

  /**********************
	AddressEntryField handlers
	**********************/
  // Handle any default value from server - Auto populate
  // passed to component
  handleAddressDefaultValue = (item) => {
    let keyName = item && item.$;

    switch (keyName) {
      case 'line1':
        return this.getAddressDefaultValue('line1', 'address1');
      case 'line2':
        return this.getAddressDefaultValue('line2', 'address2');
      case 'city':
        return this.getAddressDefaultValue('city', 'city');
      case 'state':
        return this.getAddressDefaultValue('state', 'state');
      case 'postcode':
        return this.getAddressDefaultValue('postcode', 'zip');
      default:
        return '';
    }
  };

  getAddressDefaultValue = (newAddressKey, prefillAddressKey) => {
    const newAddress = this.state.newAddress;
    return _get(newAddress, newAddressKey) || '';

    // if (isCountryChange) {
    // 	return '';
    // }

    // if (this.state.hasSavedFormData) {
    // 	return _get(newAddress, newAddressKey);
    // }

    // return _get(newAddress, newAddressKey) || '';
  };

  // passed to component - handle changes to billing address field
  handleChangeBillingField = (field, value) => {
    const newState = {};
    newState[`billing_error_${field}`] = '';
    this.setState(newState);

    let newAddress = { ...this.state.newAddress, [field]: value };
    this.setState({ newAddress: newAddress, showAddressErrors: false });

    // Only hiding in case for select
    if (field === 'state' && value) {
      this.setState({ billing_error_state: '' });
    }
  };

  /**
   * Gets all address fields which have errors
   * @return {Array} Array of address field names
   */
  getAddressFieldsWithErrors = () => {
    // fields will be an array of strings in the format `billing_error_{fieldName}`
    // Eg: [ 'billing_error_postcode', 'billing_error_city', 'billing_error_state' ]
    const fields = _keys(this.state).filter((key) => {
      return _startsWith(key, 'billing_error') && !_isEmpty(this.state[key]);
    });
    // Get field names without 'billing_error_'
    // Eg: [ 'postcode', 'city', 'state' ]
    const fieldNames = fields.map((field) => {
      return field.split('billing_error_')[1];
    });

    return fieldNames;
  };

  // passed to component - handle blur on billing address
  handleAddressBlur = (field, value) => {
    if (!value) {
      let newErrorState = {};
      newErrorState[`billing_error_${field}`] =
        errorMessages[`REQUIRED_BILLING_ADDRESS_${field.toUpperCase()}`];
      this.setState(newErrorState);
    }
  };

  // passed to component - handle postal code error
  handlePostcodeHasError = (postcode) => {
    this.setState({ postcode: postcode });
  };

  /**********************
	AddressCheckBox handlers
	**********************/
  // passed to component - handle share address checkbox state
  handleShareAddress = (isChecked) => {
    this.setState({ consentShareAddress: isChecked });
    AppActions.updateShareAddress(isChecked);
  };

  /**********************
	PhoneComponent handlers
	**********************/
  // passed to component - handling phone infomation
  handlePhoneInfo = (phone = {}) => {
    this.setState({ phone: phone });
  };

  /**********************
	Email handlers
	**********************/
  // passed to component - handles email blur
  handleEmailBlur = (email) => {
    let errCodeEmail = '';
    let emailRex = constants.EMAIL_REX;
    let cusEmail = TemplateData.donationEmail;
    if (emailRex.test(email)) {
      if (cusEmail.toUpperCase() === email.toUpperCase()) {
        errCodeEmail = 'CANNOT_PAY_SELF';
      }
    } else if (email === '') {
      errCodeEmail = 'MISSING_EMAIL_ID';
    } else {
      errCodeEmail = 'INVALID_EMAIL_ID';
    }

    let errMessageEmail = errorMessages[errCodeEmail];
    FPT.trackError({
      message: errMessageEmail,
      fieldId: 'email',
      code: errCodeEmail,
    });
    this.setState({ errMessageEmail: errMessageEmail });
  };

  // passed to component - handle email change
  handleChangeEmail = (email, mssg_error) => {
    let { user = {} } = this.state;
    user.email = email;
    this.setState({ user: user, email: email, [mssg_error]: '' });
  };

  /**********************
	CreateAccountPre handlers
	**********************/
  // passed to component - handle create account checkbox state
  handleCreateAccountCheckbox = (checked) => {
    let chkBxStatus = checked ? 'checked' : 'unchecked';
    FPT.trackLinkClickWithData('createAccount', { checkbox: chkBxStatus });
    this.setState({ passwordFieldsOpen: checked });
  };

  // passed to component - When the account creation form has all the valid input then save it
  handleCreateAccountAddInfo = (updateUser) => {
    let { user = {} } = this.state;
    user.dateOfBirth = updateUser.dateOfBirth;
    user.nationality = updateUser.nationality;
    user.occupation = updateUser.occupation;
    user.password = updateUser.password;
    user.legalValid = updateUser.legalValid;
    user.nationalId = {
      type: updateUser.nationalIdType,
      value: updateUser.nationalIdNumber,
    };
    user.consentCommunication = updateUser.consentCommunication;
    this.setState({ user: user });
  };

  // passed to component - handle reset of all saved fields from account creation form
  handleCreateAccountResetInfo = () => {
    let { user = {} } = this.state;
    user.dateOfBirth = null;
    user.nationality = null;
    user.occupation = null;
    user.password = null;
    user.legalValid = null;
    user.consentCommunication = false;
    this.setState({ user: user });
  };

  /**********************
	GuestTerms handlers
	**********************/
  // passed to component - handles checkbox validation state
  handleGuestTermsRequired = (isValid) => {
    this.setState({ isGuestTerms: isValid, termsCheckBoxError: !isValid });
  };

  /**
   * Resets sensitive fields
   * Currently only resets credit card fields
   * TODO: Reset password fields
   */
  resetSensitiveFields = () => {
    this.childPaymentInfo.resetPaymentInfo();
  };

  /**********************
	Error handlers and helpers
	**********************/
  // handle field level errors once donate button is pressed,
  // triggered when 'VALIDATION_ERROR' response is received.
  setFieldErrors = (response) => {
    let errorFileds = getErrFields(response);

    let messages = [];

    for (let i in errorFileds) {
      let errObj = errorFileds[i];
      let key = errorFileds[i].type;

      switch (key) {
        case 'INVALID_CARD_NUMBER':
          this.childPaymentInfo.handleCardNumberError('INVALID_CARD_NUMBER');
          this.handleScrollToError();
          break;
        case 'REQUIRED_CARD_NUMBER':
          this.childPaymentInfo.handleCardNumberError('REQUIRED_CARD_NUMBER');
          this.handleScrollToError();
          break;
        case 'INVALID_SECURITY_CODE':
          this.childPaymentInfo.handleSecurityCodeError(
            'INVALID_SECURITY_CODE'
          );
          this.handleScrollToError();
          break;
        case 'REQUIRED_SECURITY_CODE':
          this.childPaymentInfo.handleSecurityCodeError(
            'REQUIRED_SECURITY_CODE'
          );
          this.handleScrollToError();
          break;
        case 'INVALID_EXPIRY':
          this.childPaymentInfo.handleExpirationError('INVALID_EXPIRY');
          this.handleScrollToError();
          break;
        case 'REQUIRED_EXPIRY':
          this.childPaymentInfo.handleExpirationError('REQUIRED_EXPIRY');
          this.handleScrollToError();
          break;
        case 'REQUIRED_FIRST_NAME':
          this.childNameInfo.handleFirstNameError('REQUIRED_FIRST_NAME');
          this.handleScrollToError();
          break;
        case 'INVALID_FIRST_NAME':
          this.childNameInfo.handleFirstNameError('INVALID_FIRST_NAME');
          this.handleScrollToError();
          break;
        case 'REQUIRED_LAST_NAME':
          this.childNameInfo.handleLastNameError('REQUIRED_LAST_NAME');
          this.handleScrollToError();
          break;
        case 'INVALID_LAST_NAME':
          this.childNameInfo.handleLastNameError('INVALID_LAST_NAME');
          this.handleScrollToError();
          break;
        case 'INVALID_BILLING_ADDRESS_CITY_STATE_ZIP':
          this.handleAddressErrors(errObj);
          break;
        case 'INVALID_PHONE_NUMBER':
          this.childPhoneInfo.handlePhoneError('INVALID_PHONE_NUMBER');
          break;
        case 'REQUIRED_PHONE_NUMBER':
          this.childPhoneInfo.handlePhoneError('REQUIRED_PHONE_NUMBER');
          break;
        case 'ACCOUNT_ALREADY_EXISTS':
          this.handleExistEmailError('ACCOUNT_ALREADY_EXISTS');
          break;
        case 'MISSING_EMAIL_ID':
          this.handleExistEmailError('MISSING_EMAIL_ID');
          break;
        case 'INVALID_BILLING_ADDRESS_CITY':
          this.handleInvalidBillingAddressError(
            'city',
            'INVALID_BILLING_ADDRESS_CITY'
          );
          break;
        case 'INVALID_BILLING_ADDRESS_STATE':
          this.handleInvalidBillingAddressError(
            'state',
            'INVALID_BILLING_ADDRESS_STATE'
          );
          break;
        case 'INVALID_BILLING_ADDRESS_ZIP':
          this.handleInvalidBillingAddressError(
            'postcode',
            'INVALID_BILLING_ADDRESS_ZIP'
          );
          break;
        default:
          let message = errorMessages[key] || errorMessages.VALIDATION_ERROR;
          if (message) {
            messages.push({ key: i, value: message });
          }
          FPT.trackError({
            message: message,
            fieldId: JSON.stringify(errObj && errObj.fields),
            code: key,
          });
      }
    }
    // Updating store with any error messages from server.
    AppActions.updateServerErrors({ serverErrors: messages });
  };

  // handle email error - part of setFieldErrors()
  handleExistEmailError = (key) => {
    let errMessageEmail = errorMessages[key];
    this.setState({ errMessageEmail: errMessageEmail });
    FPT.trackError({ message: errMessageEmail, fieldId: 'email', code: key });
    this.handleScrollToError();
  };

  // handle address errors - part of setFieldErrors()
  handleAddressErrors = (errObj) => {
    let errFields = JSON.stringify(errObj.fields);
    let errorMessage = errorMessages.INVALID_BILLING_ADDRESS_CITY_STATE_ZIP;

    this.setState({
      showAddressErrors: true,
      addressErrorMessage: errorMessage,
    });
    FPT.trackError({
      message: errorMessage,
      fieldId: errFields,
      code: 'INVALID_BILLING_ADDRESS_CITY_STATE_ZIP',
    });
    this.handleScrollToError();
  };

  // handle city, state, or postal code errors - part of setFieldErrors()
  handleInvalidBillingAddressError = (fieldName, errorCode) => {
    const newErrorState = {};
    newErrorState[`billing_error_${fieldName}`] = errorMessages[errorCode];
    this.setState(newErrorState);
  };

  // handles scrolling screen to the error - part of setFieldErrors()
  handleScrollToError = () => {
    let errorEl = $(
      '.vx_has-error-with-message:visible, .service_error_holder:visible, .ppvx_field--error'
    );
    $('html, body').animate(
      { scrollTop: errorEl.offset() && errorEl.offset().top },
      1000
    );
    return;
  };

  /**********************
	Validation helpers for Guest Submit and Guest Creation process
	**********************/
  // called in handleRequiredValues()
  handleEmailRequiredFields = (params) => {
    let isValid = true;
    let emailErr;
    let keysToValidate = Object.keys(params);

    keysToValidate.forEach((key) => {
      let value = params[key];
      switch (key) {
        case 'email':
          if (!value) {
            isValid = false;
            emailErr = errorMessages.MISSING_EMAIL_ID;
            FPT.trackError({
              message: emailErr,
              fieldId: 'email',
              code: 'MISSING_EMAIL_ID',
            });
          }
          break;
        default:
          break;
      }
    });
    this.setState({ errMessageEmail: emailErr });
    return isValid;
  };

  // called in handleRequiredValues()
  handleAddressRequiredFields = (billingAddress) => {
    let {
      initialData: { addressEntryFormat = {} },
    } = this.state;
    let { allErr = [], isValid = true } = {};

    addressEntryFormat.layout.filter((field) => {
      if (field.required && field.$ && !billingAddress[field.$]) {
        isValid = false;
        let newErrorState = {};
        switch (field.$) {
          case 'line1':
            newErrorState[`billing_error_${field.$}`] =
              errorMessages.REQUIRED_ADDRESS_LINE1;
            this.setState(newErrorState);
            break;
          case 'city':
            newErrorState[`billing_error_${field.$}`] =
              errorMessages.REQUIRED_BILLING_ADDRESS_CITY;
            this.setState(newErrorState);
            break;
          case 'state':
            newErrorState[`billing_error_${field.$}`] =
              errorMessages.REQUIRED_BILLING_ADDRESS_STATE;
            this.setState(newErrorState);
            break;
          case 'postcode':
            newErrorState[`billing_error_${field.$}`] =
              errorMessages.REQUIRED_BILLING_ADDRESS_ZIP;
            this.setState(newErrorState);
            break;
          default:
            break;
        }
      }
    });
    AppActions.updateServerErrors({ serverErrors: allErr });
    return isValid;
  };

  // called in handleRequiredValues() - handling guest terms check box if required
  validateGuestTermsCheckBox = (isGuestTerms = false) => {
    const countryInfo = getCountryInfo(this.state.country);
    const isCreateAcc =
      this.state.passwordFieldsOpen ||
      TemplateData.memberMandatory ||
      AppStore.getDonationRecurring() === 'checked';
    let isValid = true;

    if (countryInfo.showGuestTermsCheckBox && !isCreateAcc) {
      this.setState({ termsCheckBoxError: !isGuestTerms });
      isValid = isGuestTerms;
    }
    return isValid;
  };

  /**********************
	Guest Submit Button & Guest Creation
	Flow:
	1. handleCreateGuest - If no errors, setGuestPaymentData
	2. setGuestPaymentData - Handles creation of 'myData' object that is passed as 'params' to handleRequiredValues
	3. handleRequiredValues - Checks that all required fields are valid by calling several other handlers.
							  If all return 'isValid', then the 'myData'/'params' obj is passed to checkAnyFormErrors
	4. checkAnyFormErrors - Performs final check for errors. If no errors, passes 'myData'/'params' obj to submitGuestPayment
	5. submitGuestPayment - Sends the post request, and performs logic operations over 'result' obj.
							In the third 'else if', if the 'request.data' and 'request.data.confirmationData' are present(true),
							then the 'confirmationData' is passed to handlePaymentSuccess. The other logic checks are for errors,
							and other circumstances, that will be redirected.
	6. handlePaymentSuccess - The payment was a success! Here, the 'response' is checked to see if the guest wants to sign up,
							  and if so, the '#guestCreateAccountdialog' model is shown. In addition, some FPT analytics stuff
							  is tagged. After the logic blocks, the response is passed to handleConfirmation.
	7. handleConfirmation - The response is checked for 'isOfacPending', which will redirect the user to the pending page,
							or the confirmation page.
	**********************/

  handleCreateGuest = (event) => {
    event.preventDefault();

    let { user } = this.state;
    let isRecurring = AppStore.getDonationRecurring() === 'checked';

    // If the user hits submit, show errors if present
    if (
      this.state.passwordFieldsOpen ||
      TemplateData.memberMandatory ||
      isRecurring
    ) {
      this.setState({
        showCreateAccountPreErrors: true,
      });
    }

    if (
      (this.state.passwordFieldsOpen ||
        TemplateData.memberMandatory ||
        isRecurring) &&
      !user.password
    ) {
      this.setState({ createaccount: true, isCreateAccValid: !!user.password });
      // if (!user.password) {
      // this.setState({ isCreateAccValid: !!user.password });
      // }
    } else {
      this.setState({ isCreateAccValid: true });
    }

    let cusEmail = TemplateData.donationEmail;
    if (cusEmail === this.state.email) {
      this.setState({ errMessageEmail: errorMessages.CANNOT_PAY_SELF });
    }
    if (!this.props.validateDonationAmountForUS()) {
      $('html, body').animate(
        { scrollTop: $('.money_input').offset().top },
        1000
      );
      return;
    }
    const donationAmount = AppStore.getDonationAmount();

    if (!isAmountGreaterThanZero(donationAmount)) {
      addShake();
      $('html, body').animate(
        { scrollTop: $('.money_input').offset().top },
        1000
      );
      return; // block the createGuest action
    }
    if ($('.vx_has-error-with-message').is(':visible')) {
      this.handleScrollToError();
      return;
    }

    this.setGuestPaymentData();
  };

  setGuestPaymentData = () => {
    let myData = AppStore.getAllData() || {};

    // The program selected in the program dropdown
    myData.selectedProgram = myData.selectedProgram;

    const { memberMandatory } = TemplateData;
    const {
      user = {},
      card = {},
      phone = {},
      newAddress = {},
      consentShareAddress,
      passwordFieldsOpen,
      DOBPattern,
      isGuestTerms,
    } = this.state;
    const { startDate: { startMonth, startYear } = {} } = card;
    const isRecurring = myData.recurring === 'checked';
    let billingAddress = {
      line1: newAddress.line1,
      city: newAddress.city,
      postalCode: newAddress.postcode,
      postcode: newAddress.postcode, // Griffin has `postcode`
      country: myData.country,
    };
    if (newAddress.line2) {
      billingAddress.line2 = newAddress.line2;
    }

    if (newAddress.state) {
      billingAddress.state = newAddress.state;
    }

    if (card.expiration) {
      let [expiryMonth = '', expiryYear = ''] = card.expiration.split('/');
      card.expiryMonth = expiryMonth;
      card.expiryYear =
        expiryYear.length === 2 ? '20' + expiryYear : expiryYear;
    }

    if (card.dateOfBirth && DOBPattern) {
      let dobDateCard = card.dateOfBirth.split('/');
      let patternsCard = DOBPattern.split('/');

      card.dobYear = dobDateCard[patternsCard.indexOf('YYYY')];
      card.dobMonth = dobDateCard[patternsCard.indexOf('MM')];
      card.dobDay = dobDateCard[patternsCard.indexOf('DD')];
    }

    myData.isGuestTerms = isGuestTerms;
    myData.user = user;
    myData.card = card;
    myData.phone = phone;
    myData.consentShareAddress = consentShareAddress;
    myData.billingAddress = billingAddress;
    myData.giftAidItFlag = AppStore.getGiftaidItFlagStatus() || false;

    if (startMonth && startYear) {
      myData.startDate = `${startMonth}/${startYear}`;
      myData.card.startYear = startYear;
      myData.card.startMonth = startMonth;
    }

    if (passwordFieldsOpen || memberMandatory || isRecurring) {
      myData.marketingOptin = user.consentCommunication;
      myData.createaccount = true;
    } else {
      myData.user.password = '';
      myData.createaccount = false;
    }

    if (myData.user.dateOfBirth && DOBPattern) {
      var dateObj = dateUtils.parseDob(myData.user.dateOfBirth, DOBPattern);

      myData.user.dobYear = dateObj.year;
      myData.user.dobMonth = dateObj.month;
      myData.user.dobDay = dateObj.day;
    }

    this.setState({ showAddressErrors: false });

    // Updating app store with message = [], as attempt to clean all server errors.
    AppActions.updateServerErrors({ serverErrors: [] });
    AppActions.updateEmail({ email: this.state.email });
    AppActions.updateBillingAddress({ billingAddress: billingAddress });

    FPT.addDonationAmount(myData.amount, window.fpti.pgrp, window.fpti.page);

    // Clone is required to prevent overriding the value of amount
    // Without this, amount will become equal to normalize(amount)
    // 1,23 will become equal to 1.23 causing UI validation error
    const dataToSubmit = _clone(myData);
    dataToSubmit.amount = normalizeNumber(myData.amount);
    this.handleRequiredValues(dataToSubmit);
  };

  handleRequiredValues = (params) => {
    let paymentStatus = this.childPaymentInfo.handleRequiredFields(params.card);
    let phoneStatus = this.childPhoneInfo.handleRequiredFields(params.phone);
    let emailStatus = this.handleEmailRequiredFields(params.user);
    let addressStatus = this.handleAddressRequiredFields(params.billingAddress);
    let termsCBStatus = this.validateGuestTermsCheckBox(params.isGuestTerms);

    this.setState(
      {
        isGuestFormValid:
          paymentStatus &&
          phoneStatus &&
          emailStatus &&
          addressStatus &&
          termsCBStatus,
      },
      () => {
        this.checkAnyFormErrors(params);
      }
    );
  };

  checkAnyFormErrors = (params) => {
    if (this.state.isGuestFormValid && this.state.isCreateAccValid) {
      this.submitGuestPayment(params);
    } else {
      this.handleScrollToError();
    }
  };

  submitGuestPayment = (params) => {
    // Save form data
    // If user navigates back to this page from CrossBorder, then we prefill this info
    this.props.saveFormData({
      country: params.country,
      user: params.user,
      giftAidItFlag: params.giftAidItFlag,
      billingAddress: params.billingAddress,
      consentShareAddress: params.consentShareAddress,
      shareAddress: params.shareAddress,
      phone: params.phone,
    });

    this.props.toggleSpinner(true);
    if (this.state.consentShareAddress) {
      FPT.trackLinkClickWithData('consentShareAddress', {
        consentShareAddress: 'true',
      });
    }

    FPT.trackLinkClick('donate');

    $.post('/donate/guest', params, (result) => {
      console.log('Result :: ', result);

      // Adding special handling for WSM_PAYMENT_DENIED because the result
      // comes back with status: redirect which results in reloading of guest page
      // without any error message
      if (result.code === 'WSM_PAYMENT_DENIED') {
        this.props.history.push('/donate/error/payment');
        return;
      } else if (result.status === 'redirect') {
        window.location.href = result.url;
        return;
      } else if (result.code === 'CROSS_BORDER' && result.fundingOpts) {
        let fundingOpts = result.fundingOpts[0];
        // Updating store with funding options
        AppActions.updateFundingOptions({ fundingOptions: fundingOpts });
        // Redirect to crossborder handler page.
        this.props.history.push('/donate/guest/crossborder');
        window.PAYPAL.analytics.startCPLTracking({
          page: 'main:donate:wps:guest:crossBorder:web::',
          action: 'crossborder_page_loaded',
          uicomp: 'crossBorder',
          uitype: 'page',
        });
      } else if (result.data && result.data.confirmationData) {
        let confirmationData = result.data.confirmationData || {};
        this.handlePaymentSuccess(confirmationData);
      } else if (
        result.code === 'WSM_TRANSACTION_FAILED_DUE_TO_INVALID_CARD_DATA' ||
        _get(result, 'error.details[0].name') ===
          'WSM_TRANSACTION_FAILED_DUE_TO_INVALID_CARD_DATA'
      ) {
        let messages = parseErrorResponse(result.data.error, errorMessages);
        // Updating store with any error messages from server.
        AppActions.updateServerErrors({ serverErrors: messages });

        // mock fulfillment error
        // pre-populate saved form data
        const formData = result.formData;
        if (formData) {
          this.props.saveFormData({
            country: formData.country,
            user: formData.user,
            giftAidItFlag: formData.giftAidItFlag,
            billingAddress: formData.billingAddress,
            consentShareAddress: formData.consentShareAddress,
            shareAddress: formData.shareAddress,
            phone: formData.phone,
          });
        }
      } else if (result.code === 'VALIDATION_ERROR') {
        this.setFieldErrors(result);
        this.resetSensitiveFields();
      } else if (result.code === 'WSM_CANNOT_PAY_SELF') {
        let messages = parseValErrResp(
          result,
          errorMessages,
          'WSM_CANNOT_PAY_SELF'
        );
        // Updating store with any error messages from server.
        AppActions.updateServerErrors({ serverErrors: messages });
      } else if (result.message === 'CC_LINKED_TO_FULL_ACCOUNT') {
        let messages = parseValErrResp(
          result,
          errorMessages,
          'CC_LINKED_TO_FULL_ACCOUNT'
        );
        // Updating store with any error messages from server.
        AppActions.updateServerErrors({ serverErrors: messages });
      } else if (result.code === 'ADD_CARD_CONTINGENCY') {
        let messages = parseValErrResp(
          result,
          errorMessages,
          'ISSUER_DECLINE_ERROR'
        );
        AppActions.updateServerErrors({ serverErrors: messages });
      } else if (result.message === 'ISSUER_DECLINE_ERROR') {
        let messages = parseValErrResp(
          result,
          errorMessages,
          'ISSUER_DECLINE_ERROR'
        );
        // Updating store with any error messages from server.
        AppActions.updateServerErrors({ serverErrors: messages });
      } else if (result.message === 'RISK_DISALLOWED') {
        let messages = parseValErrResp(
          result,
          errorMessages,
          'RISK_DISALLOWED'
        );
        // Updating store with any error messages from server.
        AppActions.updateServerErrors({ serverErrors: messages });
      } else if (
        result.code === '3D_SECURE_DATA_COLLECTION_REQUIRED' &&
        result.fundingOpts
      ) {
        let fundingOpts = result.fundingOpts[0];
        // Updating store with funding options
        AppActions.updateFundingOptions({ fundingOptions: fundingOpts });

        FPT.addFi(
          fundingOpts,
          'main:donate:wps:guest:3DS-challenge',
          'main:donate:wps:guest:3DS-challenge:::'
        );
        FPT.add3DSInitData(
          fundingOpts,
          'main:donate:wps:guest:3DS-challenge',
          'main:donate:wps:guest:3DS-challenge:::'
        );

        this.threeDSContainer.initializeThreeDS();

        return;
      } else {
        // Control reaches here for contingency errors also - 'INVALID_CONTINGENCIES' and 'WSM_UNRESOLVED_CONTINGENCIES'
        // Updating store with payment error from server.
        AppActions.updatePaymentError({ paymentError: result && result.code });
        this.props.history.push('/donate/error/payment');
      }
    })
      .fail(() => {
        // Handle any wierd errors from service
        this.props.history.push('/donate/error/payment');
      })
      .always(() => {
        this.props.toggleSpinner(false);
      });
  };

  handlePaymentSuccess = (response) => {
    AppActions.updateConfirmation({ confirmation: response });
    startCustomCPLTrackingForConfirmationPage();

    if (
      response.guestSignUp &&
      response.experiment &&
      response.experiment.treatment_name ===
        'US_cause_guest_donation_flow_treatment'
    ) {
      FPT.trackPageWithData(
        'main:donate:wps:guest:upgrade',
        'main:donate:wps:guest:upgrade:web::',
        {
          xe: response.experiment.experiment_id,
          xt: response.experiment.treatment_id,
        }
      );
      this.setState({ isSignUpPanel: true });
      setTimeout(() => $('#guestCreateAccountdialog').modal('show'), 100);
    } else if (
      response.guestSignUp &&
      response.experiment &&
      response.experiment.treatment_name ===
        'US_cause_guest_donation_flow_control'
    ) {
      FPT.addPxpTags({
        xe: response.experiment.experiment_id,
        xt: response.experiment.treatment_id,
      });
      return this.handleConfirmation(response);
    } else {
      return this.handleConfirmation(response);
    }
  };

  handleConfirmation = (response) => {
    if (response.isOfacPending) {
      this.props.history.push('/donate/guest/pending');
    } else {
      this.props.history.push('/donate/guest/confirmation');
    }
  };

  setCountryAndLocaleInLinks = (createAccountPreProps) => {
    createAccountPreProps.legalBlurbHTML = getCountryInfo(this.state.country)
      .termsAndConditionsWithFeeInformationDoc
      ? setCountryAndLocale(
          createAccountPreProps.legalBlurbWithFeeInformationDoc
        )
      : setCountryAndLocale(createAccountPreProps.legalBlurbHTML);
    createAccountPreProps.consentBlurbHTML = setCountryAndLocale(
      createAccountPreProps.consentBlurbHTML
    );
    createAccountPreProps.legalOnlyHTML = setCountryAndLocale(
      createAccountPreProps.legalOnlyHTML
    );
  };

  handleThreeDSStepUpAuthSuccess = () => {
    this.props.toggleSpinner(true);
    this.props.doFulfilment({
      securityCode: _get(this.state, 'card.securityCode'),
    });
  };
  handleThreeDSFailure = () => {
    // Unrecoverable error !!
    this.props.history.push('/donate/error/threeDS');
  };

  render() {
    const allGuestMessages = guestLocalsMessages();
    const signUpHeader =
      allGuestMessages.createAccountPreProps &&
      allGuestMessages.createAccountPreProps.mainTitle2;
    const { guestLabels } = allGuestMessages;

    let {
      recurringEnabled,
      initialData: { addressEntryFormat = {} },
    } = this.state;
    let isRecurring = AppStore.getDonationRecurring() === 'checked';
    let showCreateAccount =
      recurringEnabled && isRecurring ? true : this.state.memberMandatory;
    let showTermsCheckbox = this.state.passwordFieldsOpen || showCreateAccount;
    let recieveMailLabel = guestLabels.recieveMail;
    let recieveMailToolTip = guestLabels.recieveMailToolTip;
    let orgName = TemplateData.donationName;

    recieveMailLabel = recieveMailLabel.replace('{orgName}', orgName);
    recieveMailToolTip = recieveMailToolTip.replace('{orgName}', orgName);
    recieveMailToolTip = recieveMailToolTip.replace('{orgName}', orgName);

    allGuestMessages.createAccountPreProps.mainTitle =
      TemplateData.memberMandatory || (recurringEnabled && isRecurring)
        ? signUpHeader
        : '';

    this.setCountryAndLocaleInLinks(allGuestMessages.createAccountPreProps);

    if (this.state.country === 'RU') {
      return (
        <RussiaGuestForm
          supportedCountries={this.state.supportedCountries}
          currentCountry={this.state.country}
          countryLabel={guestLabels.country}
          changeCountry={(country) => this.props.handleCountryChange(country)}
        />
      );
    }

    return (
      <div className="donate_guest_form_wrapper">
        <div className="ppvx_row">
          <div className="ppvx_col-sm-12 text-center">
            <CountrySelection
              label={guestLabels.country}
              supportedCountries={this.state.supportedCountries}
              defaultValue={this.state.country}
              changeCountry={(country) =>
                this.props.handleCountryChange(country)
              }
              errorMessage={this.state.errMessageCountry}
            />
          </div>
        </div>
        <div className="ppvx_row">
          <div className="ppvx_col-sm-12 creditcard_number">
            <PaymentComponent
              onRef={(ref) => (this.childPaymentInfo = ref)}
              changePaymentInfo={this.handleChangePaymentInfo}
              country={this.state.country}
              {...allGuestMessages}
              errorMessages={errorMessages}
              {...this.state.initialData}
            />
          </div>
        </div>
        <div className="ppvx_row has_combo">
          <div className="ppvx_col-sm-12 creditcard_number">
            <NameComponent
              onRef={(ref) => (this.childNameInfo = ref)}
              {...allGuestMessages}
              errorMessages={errorMessages}
              isRequired={this.state.isRequired}
              {...this.state.initialData}
              guestLabels={guestLabels}
              changeNameInfo={this.handleChangeNameInfo}
              user={this.state.user}
            />
          </div>
        </div>

        {this.state.showAddressErrors && (
          <Alert className="ppvx_col-sm-12 service_error_holder" type="error">
            {this.state.addressErrorMessage}
          </Alert>
        )}

        <FormSectionHeading heading={guestLabels.billing} />
        <div className="ppvx_row address_fields" style={{ marginTop: -10 }}>
          {addressEntryFormat.layout
            .filter((field) => field._ !== undefined)
            .map((field) => (
              <AddressEntryField
                key={`${field.$}`}
                {...field}
                id={`billing_${field.$}`}
                value={this.handleAddressDefaultValue(field)}
                fieldName={field.$}
                labels={addressEntryFormat.strings}
                country={this.state.country}
                handleChangeField={this.handleChangeBillingField}
                handleBlur={this.handleAddressBlur}
                errorMessage={this.state[`billing_error_${field.$}`]}
                handlePostcodeHasError={this.handlePostcodeHasError}
              />
            ))}
        </div>

        {TemplateData.isShipping && (
          <AddressCheckbox
            changeAddress={this.handleShareAddress}
            label={recieveMailLabel}
            toolTipText={recieveMailToolTip}
          />
        )}

        <FormSectionHeading heading={guestLabels.contactinfo} />
        <div className="ppvx_row has_combo">
          <div className="ppvx_col-sm-12">
            <PhoneComponent
              onRef={(ref) => (this.childPhoneInfo = ref)}
              {...allGuestMessages}
              {...this.state.initialData}
              defaultNumber={this.state.phone}
              errorMessages={errorMessages}
              isRequired={this.state.isRequired}
              handlePhoneInfo={this.handlePhoneInfo}
            />
          </div>
        </div>
        <div style={{ marginTop: '-10px' }} className="email_holder">
          <Email
            label={guestLabels.email}
            errorMessage={this.state.errMessageEmail}
            handleBlur={this.handleEmailBlur}
            value={this.state.email}
            required={this.state.isRequired}
            changeEmail={this.handleChangeEmail}
          />
        </div>
        <div>
          <div
            className="password_fields"
            style={{ marginTop: 20, marginBottom: 20, textAlign: 'initial' }}
          >
            <CreateAccountPre
              {...allGuestMessages.createAccountPreProps}
              dobPattern={this.state.DOBPattern}
              mandatory={showCreateAccount}
              country={this.state.country}
              supportedCountries={this.state.assignedCountries}
              handleCreateAccountCheckbox={this.handleCreateAccountCheckbox}
              handleValidInfo={() => {}}
              resetValidInfo={() => {}}
              handleAllValidInfo={this.handleCreateAccountAddInfo}
              resetAllValidInfo={this.handleCreateAccountResetInfo}
              showValidationErrors={this.state.showCreateAccountPreErrors}
            />
          </div>
        </div>

        <GuestTerms
          hasError={this.state.termsCheckBoxError}
          handleRequired={this.handleGuestTermsRequired}
          country={this.state.country}
          isChecked={this.state.isGuestTerms}
          mandatory={this.state.memberMandatory}
          isSignUp={showTermsCheckbox}
        />

        <GuestSubmitButton
          amount={this.state.formatedAmount}
          labels={guestLabels}
          isRecurring={isRecurring}
          disabled={this.props.donateDisabled}
          handleClick={this.handleCreateGuest}
          passwordFieldsOpen={this.state.passwordFieldsOpen}
          country={this.state.country}
        />
        <CancelAndReturn />

        <ThreeDSContainer
          onThreeDSStepUpAuthNotRequired={this.handleThreeDSStepUpAuthSuccess}
          onThreeDSStepUpAuthSuccess={this.handleThreeDSStepUpAuthSuccess}
          onThreeDSStepUpAuthFailure={this.handleThreeDSFailure}
          onThreeDSFailure={this.handleThreeDSFailure}
          onRef={(ref) => (this.threeDSContainer = ref)}
        />
      </div>
    );
  }
}

GuestForm.propTypes = {
  validateDonationAmountForUS: PropTypes.func,
  history: PropTypes.object,
  toggleSpinner: PropTypes.func,
  handleCountryChange: PropTypes.func,
  donateDisabled: PropTypes.bool,
  getFormData: PropTypes.func,
  saveFormData: PropTypes.func,
  doFulfilment: PropTypes.func,
};

export default withRouter(withDonate(GuestForm));
